/**
 * @fileoverview Composed User Provider - Combines all user contexts
 * Part of Phase 2.3 context optimization - composition pattern
 */

import type { ReactNode } from 'react';
import { UserProfileProvider } from './UserProfileContext';
import { UserLimitsProvider } from './UserLimitsContext';
import { UserProgressProvider } from './UserProgressContext';

interface ComposedUserProviderProps {
    children: ReactNode;
}

/**
 * Composed user provider that combines all user-related contexts
 * Uses composition pattern to maintain separation of concerns
 * while providing a single wrapper component
 */
export const ComposedUserProvider = ({ children }: ComposedUserProviderProps) => {
    return (
        <UserProfileProvider>
            <UserLimitsProvider>
                <UserProgressProvider>
                    {children}
                </UserProgressProvider>
            </UserLimitsProvider>
        </UserProfileProvider>
    );
};
